"use client"

import { CustomLink } from '@/src/components/custom-link';
import Image from 'next/image';

import logoLight from 'public/assets/images/brand/SocLogoEN.webp';
import logoDark from 'public/assets/images/brand/SocLogoENDark.webp';
import logoLightAr from 'public/assets/images/brand/logo-darkAR.png';
import logoDarkAr from 'public/assets/images/brand/logo-darkAR.png';

interface Props {
  params: { lang: string };
}

export function BrandLogo({params}: Props) {
  const  isArabic =  params?.lang === "ar";
  return (
    <CustomLink href={isArabic ? "/ar" : "/en"}>
      {/* Light Mode Logo */}
      <div className="dark:hidden">
        <Image
          className="logo-light"
          src={isArabic ? logoDarkAr : logoLight}
          width={200} 
          height={72}
          placeholder="blur"
          blurDataURL={logoLight.blurDataURL}
          alt={`${process.env.NEXT_PUBLIC_SITE_NAME} brand logo`}
          priority
        />
      </div>

      {/* Dark Mode Logo */}
      <div className="hidden dark:block">
        <Image
          className="logo-dark"
          src={isArabic ? logoLightAr : logoDark}
          width={200} 
          height={72}
          placeholder="blur"
          blurDataURL={logoDark.blurDataURL}
          alt={`${process.env.NEXT_PUBLIC_SITE_NAME} brand logo`}
          priority
        />
      </div>
    </CustomLink>
  );
}
